import { useSdk } from '~/sdk';

export const useSearchProduct = (search:string, page:number, pageSize: number, sort:any) => {
  const state = useState(`useSearchProduct-${search}`, () => ({
    data: null,
    loading: false,
  }));

  const searchWithKeyword = async (search:string, page:number, pageSize: number, sort:any) => {
    state.value.loading = true;
    const { data, error } = await useAsyncData(async () => {
      return await useSdk().magento.search(search, page, pageSize, sort);
    });
    return data.value
  };

  const topSearchWithKeyword = async (search:string, page:number, pageSize: number, sort:any) => {
    state.value.loading = true;
    const { data, error } = await useAsyncData(async () => {
      return await useSdk().magento.search(search, page, pageSize, sort);
    });
    const products = data.value?.products?.items;
    const productList = computed(
      () =>
        products?.map(({ name, sku, image, url_key }) => ({
          title: name,
          subtitle: sku,
          image: image.url,
          url: `${paths.product}${url_key}`,
        })) || [],
    );
    console.log(error.value);
    state.value.data = {Product: productList};
    state.value.loading = false;

    return {Product: productList};
    
  };

  return {
    searchWithKeyword,
    topSearchWithKeyword,
    ...toRefs(state.value),
  };
};
